import React from 'react';
import PropTypes from 'prop-types';
import EN from '../../EN.json';
import FR from '../../FR.json';

const MessageDialog = ({ message, isClose }) => {
  // const { message} = responseObj && responseObj;
  const {
    USERS: {
      BULK_FILE_UPLOAD: { CLOSE }
    }
  } =  localStorage.getItem('locale') ? (localStorage.getItem('locale') === 'EN' ? EN : FR) : EN;
  return (
    <>
      <div id="overlay-layer">
        <div id="overlay-story">
          <div>
            <span>{message}</span>
          </div>
          {/* <div style={{ marginTop: 20 }}>
                <h1>{BULK_FILE_USER} : {bulkUsers.length}</h1>
                <h1>{REGISTER_USER}: {registeredUsers.length}</h1>
                <h1>{REJECTED_USER}: {rejectedUsers.length}</h1>
                {rejectedUsers && rejectedUsers.length > 0 && <Table rejectedUsers={rejectedUsers} /> }    
              </div> */}
          <button
            type="button"
            style={{ marginTop: '15px' }}
            className="frg-button color-purple"
            onClick={() => isClose()}
          >
            {CLOSE}
          </button>
        </div>
      </div>
    </>
  );
};

MessageDialog.propTypes = {
  message: PropTypes.string.isRequired,
  isClose: PropTypes.func.isRequired
};
export default MessageDialog;
